var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M39.988,12c0,0,1,23-15.816,32c-17.16-9-16.16-32-16.16-32C16.008,12,24,4,24,4 S30.996,12,39.988,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d4037",
    d: "M33,21.297l-1.762-3.168l-4.477,1.348L25.848,15h-3.695l-0.91,4.445l-4.438-1.367L15.02,21.23 l3.34,2.746L15,26.703l1.762,3.164l4.477-1.344L22.152,33h3.695l0.91-4.445l4.434,1.367l1.785-3.152l-3.336-2.75L33,21.297z M28.617,24c0,2.484-2.066,4.5-4.617,4.5s-4.617-2.016-4.617-4.5s2.066-4.5,4.617-4.5S28.617,21.516,28.617,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d4037",
    d: "M30.5,24c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5S30.5,27.59,30.5,24z M27,24 c0,1.656-1.344,3-3,3s-3-1.344-3-3s1.344-3,3-3S27,22.344,27,24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.479e7633.svg";
export { ForwardRef as ReactComponent };